export default __webpack_public_path__ + "static/media/219.78d21d5f.svg";